import { render, staticRenderFns } from "./DonationAddButton.vue?vue&type=template&id=7234b431&"
import script from "./DonationAddButton.vue?vue&type=script&lang=js&"
export * from "./DonationAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports